export function isFolderItem(s) {
  return !!s.elements;
}